export default __webpack_public_path__ + "static/media/img_04.31e8fbfd.webp";